import Wrapper from '@components/image/Wrapper'
import BlogImage from '@components/blog/components/BlogImage'

function PostMainPhoto ({ src, alt, title } = {}) {
    return src
        ? (
            <Wrapper>
                <BlogImage {...{ src, alt, title, breakpoint: null }} />
            </Wrapper>
          )

        : null
}

export default PostMainPhoto